<style>
</style>

<template>
    <div class="animated fadeIn">
        <b-tabs fill>
            <b-tab v-if="Core.Session.AuthUser.can('report_event_booking')">
                <template slot="title">
                    <i class="icon-user-following mr-2"></i>{{Core.Definition.getDefinition('Réservations')}}
                </template>
                <ReportEventBooking class="mt-4"></ReportEventBooking>
            </b-tab>
            <b-tab v-if="Core.Session.AuthUser.can('report_event_visit')">
                <template slot="title">
                    <i class="fa fa-user-secret mr-2"></i>{{Core.Definition.getDefinition('Visites')}}
                </template>
                <ReportEventVisit class="mt-4"></ReportEventVisit>
            </b-tab>
            <b-tab v-if="Core.Session.AuthUser.can('report_event_popularity')">
                <template slot="title">
                    <i class="fa fa-thumbs-up mr-2"></i>{{Core.Definition.getDefinition('Popularité')}}
                </template>
                <ReportEventPopularity class="mt-4"></ReportEventPopularity>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import ReportEventBooking from './Booking'
    import ReportEventPopularity from './Popularity'
    import ReportEventVisit from './Visit'
    export default {
        name: 'ReportEventPanel',
        components: {
            ReportEventBooking,
            ReportEventPopularity,
            ReportEventVisit
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core
            }
        },
        computed: {
        },
        methods: {
        }
    }
</script>
